export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ06B.c69c21d0.mp3";